import type { TooltipProps } from './Tooltip.types';

export const tooltipCSSPropsKeys: (keyof TooltipProps)[] = [
  'height',
  'maxHeight',
  'minHeight',
  'maxWidth',
  'minWidth',
  'width',
];
